'use strict';

import { partial } from 'lodash';

var React = require('react');
var ComponentFactory = require('../../../infrastructure/ComponentFactory');

/** @module ThumbnailMarkdown
 * @requires lodash
 * @requires react
 * @requires ComponentFactory
 */
var ThumbnailMarkdown = ComponentFactory.Create({
	displayName: "ThumbnailMarkdown",
	propTypes: {
		contentItem: React.PropTypes.object.isRequired,
		picked: React.PropTypes.bool,
		onPick: React.PropTypes.func,
		onDelete: React.PropTypes.func
	},

	/**
	 * @method render
	 */
	render: function() {
		var createMarkup = function createMarkup(content) { return {__html: content || ""}; };
		return (
			<div
				onClick={this.props.onPick && partial(this.props.onPick, this.props.contentItem)}
				className={this.css("image-library-thumbnail markdown-thumbnail", {"picked": this.props.picked})}
			>
				<div className="content" dangerouslySetInnerHTML={createMarkup(this.props.contentItem.content)} />
				<div className="details">
					<div className="icon">
						<i className="mdi mdi-markdown" />
					</div>
					<div className="title">
						<p>{this.props.contentItem.name}</p>
					</div>
				</div>
			</div>
		);
	}

});

module.exports = ThumbnailMarkdown;
